import React, { useEffect, useState } from "react";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import CustomFormDialog from "../CustomFormDialog";

const AddOtherPartyDialog = ({ isOpen, onClose, authHeader }) => {
    const [otherPartiesTypes, SetOtherPartiesTypes] = useState([]);

    useEffect(() => {
        const getOtherPartiesTypes = async () => {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/otherparty/gettypes`,
                {
                    method: "GET",
                    headers: {
                        Authorization: authHeader,
                        "Content-Type": "application/json",
                    },
                },
            );
            if (response.ok) {
                const responseData = await response.json();
                SetOtherPartiesTypes(responseData.otherpartyTypes);
            }
        };
        getOtherPartiesTypes();
    }, [authHeader]);

    const formFields = [
        { name: "name", label: "Name", type: "text", required: true },
        { name: "phone", label: "Phone", type: "text" },
        { name: "address", label: "Address", type: "text" },
        { name: "taxNumber", label: "Tax Number", type: "text" },
        {
            name: "typeId",
            label: "Type",
            type: "select",
            options: otherPartiesTypes.map((type) => ({
                value: type.id,
                label: type.name,
            })),
        },
    ];

    const handleSubmit = async (formData) => {
        const response = await fetch(
            `${REACT_APP_BACKEND_URL}/otherparty/create`,
            {
                method: "POST",
                headers: {
                    Authorization: authHeader,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            },
        );
        if (response.ok) {
            onClose();
        }
    };

    return (
        <CustomFormDialog
            title="Add Other Party"
            fields={formFields}
            open={isOpen}
            onClose={onClose}
            handleSubmitClick={handleSubmit}
        />
    );
};

export default AddOtherPartyDialog;
